import SaveController from './vd-save.controller'
import template from './vd-save.html'

const SaveComponent = {
  bindings: {
    lastUpdated: '<',
    form: '<',
    disabled: '<',
    saving: '<',
    onSave: '&',
  },
  controller: SaveController,
  template,
}

export default SaveComponent
